jQuery(document).ready(function($){
    if($('.login.wp-core-ui').length){
        $('#user_login').attr('placeholder', 'Gebruikersnaam of e-mailadres');
        $('#user_pass').attr('placeholder', 'Wachtwoord')
    }

    $('.menu-item:has(.sub-menu) > a').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.menu-item').toggleClass('expanded').find('.sub-menu').toggleClass('visible');
    });
    $('.menu-item.current_page_item').closest('.sub-menu').addClass('visible');

    $('.popup__close').on('click', function() {
        $('.popup').addClass('hidden');
        setCookie('gribus_popup_closed', 'true', 1);
    });
    if(getCookie('gribus_popup_closed') == 'true') {
        $('.popup').addClass('hidden')
    }

    $('.navbar__hamburger').on('click', function() {
        $(this).closest('.sidebar').toggleClass('navbar--expanded')
    });

    $('.navbar__btn').on('click', function() {
        $(this).closest('.sidebar').removeClass('navbar--expanded')
    });

    animate($);
});

jQuery(window).scroll(function() {
    animate(jQuery)
});

function animate($) {
    $('.animated:not(.animate)').each(function() {
        if ($(this).is('.content')) {
            $(this).children().each(function() {
                if (isInViewport($(this))) {
                    $(this).addClass('animate');
                }
            });
        } else {
            if (isInViewport($(this))) {
                $(this).addClass('animate');
            }
        }
    });
}

function setCookie(name,value,hours) {
    var expires = "";
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function isInViewport(elem) {
    var elementTop = elem.offset().top;
    var elementBottom = elementTop + elem.outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    if(!elem.is('.footer__partner-content')) {
        if(jQuery(document).width() > 768) {
            viewportBottom -= 200;
        } else {
            viewportBottom -= 100;
        }
    }
    return elementBottom > viewportTop && elementTop < viewportBottom;
};